import { Observable } from 'rxjs';

import {
  TasaPatchBody,
  TasaPatchResponse,
  TasaRead,
} from '@app/data/dtos/tpv/tasas.dto';

/**
 * Port de tasas de comisión por eje — contrato CONTRATO_TASAS_FRONT.md §1.
 *
 * Cada nivel resuelve un endpoint `/tasa/` distinto con el MISMO shape:
 *  - Empresa   → `companies/<idCompany>/tasa/` (Tasa Banco).
 *  - Unidad    → `companies/<idCompany>/units/<idUnit>/tasa/` (Tasa Reseller).
 *  - Comercio  → `merchants/<idMerchant>/tasa/` (Tasa Comercio).
 *
 * IDs: `idCompany` es dual-accept (PK org entero o UUID TPV); `idUnit`/`idMerchant`
 * son UUID. Auth: admin de empresa (empresa/unidad y GET comercio); admin del
 * comercio para PATCH comercio (operador acotado → 403).
 *
 * ⚠️ Confidencialidad (RN-10): cada GET trae SOLO las tasas de su nivel. Para
 * pintar el "piso" de UN/Comercio, consultar el GET del nivel SUPERIOR — la
 * misma sesión admin puede.
 */
export abstract class TasasRepository {
  // ── Empresa (Tasa Banco) ───────────────────────────────────────────────────
  abstract getCompanyTasa(idCompany: string): Observable<TasaRead | null>;
  abstract updateCompanyTasa(
    idCompany: string,
    body: TasaPatchBody,
  ): Observable<TasaPatchResponse>;

  // ── Unidad (Tasa Reseller) ─────────────────────────────────────────────────
  abstract getUnitTasa(idCompany: string, idUnit: string): Observable<TasaRead | null>;
  abstract updateUnitTasa(
    idCompany: string,
    idUnit: string,
    body: TasaPatchBody,
  ): Observable<TasaPatchResponse>;

  // ── Comercio (Tasa Comercio) ───────────────────────────────────────────────
  abstract getMerchantTasa(idMerchant: string): Observable<TasaRead | null>;
  abstract updateMerchantTasa(
    idMerchant: string,
    body: TasaPatchBody,
  ): Observable<TasaPatchResponse>;
}
